import { useMemo } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { selectOwnedPins, useTrackerPins } from '@/stores/trackerPins';
import { isKalshiOrderPin } from '@/views/PositionTracker/pinIdentity';

/** #943 — venue ids of the signed-in user's pinned Kalshi orders: what bulk
 *  cancels skip, and what direct cancels (ladder level, close & cancel) name
 *  as "includes N pinned". Stable until the pins change. */
export function usePinnedKalshiOrderIds(): ReadonlySet<string> {
  const viewerId = useAuthStore((s) => s.user?.id ?? null);
  const entries = useTrackerPins((s) => selectOwnedPins(s, viewerId));
  return useMemo(() => new Set(entries.filter(isKalshiOrderPin).map((e) => e.key)), [entries]);
}
